<template>
	<div>
		<div>
			<span class="xbed-sub-title">管家库存明细表</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>管家物资出入库表</BreadcrumbItem>
				<BreadcrumbItem>管家库存明细表</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
		<Form @submit.native.prevent="preventSubmit" inline>
			<FormItem prop="dateTime" label="创建时间：" :label-width="100">
				<DatePicker type="daterange" v-model="dateTime" placeholder="选择日期" :clearable="false" class="date-time" style="width: 240px"></DatePicker>
			</FormItem>
			<FormItem label="一级类别：" prop="goodsCatalog" :label-width="100">
				<Select ref="register" v-model="goodsdetailsParams.goodsCatalog" filterable style="width:150px">
					<Option :value="0">全部</Option>
					<Option :value="1">个护用品</Option>
					<Option :value="2">布草</Option>
					<Option :value="3">家电</Option>
					<Option :value="4">家具</Option>
					<Option :value="5">家居装饰</Option>
					<Option :value="6">其他</Option>
				</Select>
			</FormItem>
			<FormItem label="出入库类型：" prop="entryExitType" :label-width="100">
				<Select ref="register" v-model="goodsdetailsParams.entryExitType" filterable style="width:150px">
					<Option :value="0">全部</Option>
					<Option :value="1">入库</Option>
					<Option :value="2">出库</Option>
				</Select>
			</FormItem>
			<FormItem label="更新类型：" prop="updateType" :label-width="100">
				<Select ref="register" v-model="goodsdetailsParams.updateType" filterable style="width:150px">
					<Option :value="0">全部</Option>
					<Option :value="1">期初</Option>
					<Option :value="2">领用</Option>
					<Option :value="3">归还</Option>
					<Option :value="4">补充</Option>
				</Select>
			</FormItem>
			<FormItem label="更新状态：" prop="updateStatus" :label-width="100">
				<Select ref="register" v-model="goodsdetailsParams.updateStatus" filterable style="width:150px">
					<Option value="0">全部</Option>
					<Option value="申请中">申请中</Option>
					<Option value="待领用">待领用</Option>
					<Option value="已领用">已领用</Option>
					<Option value="待归还">待归还</Option>
					<Option value="已归还">已归还</Option>
					<Option value="已失效">已失效</Option>
					<Option value="已补充">已补充</Option>
				</Select>
			</FormItem>
			<FormItem label="物品名称：" prop="goodsName" :label-width="100">
				<Input type="text" v-model="goodsdetailsParams.goodsName" style="width:150px"></Input>
			</FormItem>
			<FormItem label="关联城市：" prop="goodsName" :label-width="100">
				<Input type="text" v-model="goodsdetailsParams.associatedCityName" style="width:150px"></Input>
			</FormItem>
			<FormItem label="关联中心仓：" prop="associatedRepositoryName" :label-width="100">
				<Input type="text" v-model="goodsdetailsParams.associatedRepositoryName"></Input>
			</FormItem>
			<FormItem label="关联房间：" prop="associatedRoomName" :label-width="100">
				<Input type="text" v-model="goodsdetailsParams.associatedRoomName" style="width:150px"></Input>
			</FormItem>
			<FormItem label="关联单号：" prop="associatedNumber" :label-width="100">
				<Input type="text" v-model="goodsdetailsParams.associatedNumber" style="width:180px"></Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="queryAccountKeywords">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportTable" :loading="exportBtn">导出表格</Button>
			</FormItem>
		</Form>
		<Content>
			<Table stripe :columns="columns" :data="accountList" :loading='materialLoading'></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :current="goodsdetailsParams.page" :total="listTotal" :page-size="goodsdetailsParams.pageSize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
			</div>
		</Content>
	</div>
</template>
<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
		this.goodsdetailsParams.cleanerId = Utils.getUrlParameterByName( 'cleanerId' )
	},
	data() {
		return {
			exportBtn: false,
			// 分页
			listTotal: 0,
			// 时间段
			dateTime: [
				Moment().subtract( 6, 'day' ).format( 'YYYY-MM-DD' ),
				Moment().format( 'YYYY-MM-DD' )
			],
			materialLoading: false,
			// 查询
			goodsdetailsParams: {
				cleanerId: '',
				goodsCatalog: 0, //一级类别
				entryExitType: 0, //出入库类型
				updateType: 0, //更新类型
				updateStatus: '0',//更新状态
				goodsName: "",
				associatedRepositoryName: "",
				associatedRoomName: "",
				associatedNumber: "",
				page: 1,
				pageSize: 10,
				beginDate: "",
				endDate: "",
				associatedCityName: ''
			},
			queryParams: {
				cleanerId: '',
				goodsCatalog: 0, //一级类别
				entryExitType: 0, //出入库类型
				updateType: 0, //更新类型
				updateStatus: '0', //更新状态
				goodsName: "",
				associatedRepositoryName: "",
				associatedRoomName: "",
				associatedNumber: "",
				page: 1,
				pageSize: 10,
				beginDate: "",
				endDate: "",
				associatedCityName: ''
			},
			accountList: [],
			columns: [
				{
					title: "创建时间",
					align: "center",
					key: "createDate",
					width: 130,
					render: ( h, param ) => {
						return h(
							"span",
							param.row.createDate ? Moment( param.row.createDate ).format( "YYYY-MM-DD HH:mm:ss" ) : ''
						);
					}
				},
				{
					title: "管家姓名",
					align: "center",
					key: "cleanerName",
					width: 100
				},
				{
					title: "管家号码",
					align: "center",
					key: "cleanerAccount",
					width: 150
				},
				{
					title: "管家城市",
					align: "center",
					key: "associatedCityName",
					width: 150
				},
				{
					title: "物品id",
					align: "center",
					key: "goodsId",
					width: 100
				},
				{
					title: "物品名称",
					align: "center",
					key: "goodsName",
					width: 150
				},
				{
					title: "物料编号",
					align: "center",
					key: "stockNumber",
					width: 150
				},
				{
					title: "一级类别",
					align: "center",
					key: "goodsCatalog",
					width: 100,
					render: ( h, params ) => {
						const status = [
							"",
							"个护用品",
							"布草",
							"家电",
							"家具",
							"家居装饰",
							"其他",
						][params.row.goodsCatalog];
						return h( "span", {}, status );
					}
				},
				{
					title: "规格",
					align: "center",
					key: "goodsDesc",
					width: 100
				},
				{
					title: "出入库类型",
					key: "entryExitType",
					align: "center",
					width: 120,
					render: ( h, params ) => {
						const status = params.row.entryExitType == 1 ? "入库" : params.row.entryExitType == 2 ? "出库" : '';
						return h( "div", {}, status );
					}
				},
				{
					title: "更新类型",
					align: "center",
					key: "updateType",
					width: 100,
					render: ( h, params ) => {
						const updateType = ["", "期初", "领用", "归还", "补充"][
							params.row.updateType
						];
						return h( "div", {}, updateType );
					}
				},
				{
					title: "更新数量",
					align: "center",
					key: "updateNumber",
					width: 100
				},
				// {
				//   title: "单价（元）",
				//   align: "center",
				//   key: "unitPrice",
				//   width: 100,
				//   render: (h, params) => {
				//     const unitPrice = params.row.unitPrice
				//       ? (params.row.unitPrice / 100).toFixed(2)
				//       : 0;
				//     return h("span", unitPrice);
				//   }
				// },
				// {
				//   title: "金额（元）",
				//   align: "center",
				//   key: "totalPrice",
				//   width: 100,
				//   render: (h, params) => {
				//     const totalPrice = params.row.totalPrice
				//       ? (params.row.totalPrice / 100).toFixed(2)
				//       : 0;
				//     return h("span", totalPrice);
				//   }
				// },
				// {
				//   title: "税额（元）",
				//   align: "center",
				//   key: "taxPrice",
				//   width: 100,
				//   render: (h, params) => {
				//     const taxPrice = params.row.taxPrice
				//       ? (params.row.taxPrice / 100).toFixed(2)
				//       : 0;
				//     return h("span", taxPrice);
				//   }
				// },
				// {
				//   title: "价税合计（元）",
				//   align: "center",
				//   key: "totalPriceWithTax",
				//   width: 100,
				//   render: (h, params) => {
				//     const totalPriceWithTax = params.row.totalPriceWithTax
				//       ? (params.row.totalPriceWithTax / 100).toFixed(2)
				//       : 0;
				//     return h("span", totalPriceWithTax);
				//   }
				// },
				{
					title: "出入库时间",
					align: "center",
					key: "storageTime",
					width: 130,
					render: ( h, param ) => {
						return h(
							"span",
							param.row.storageTime ? Moment( param.row.storageTime ).format( "YYYY-MM-DD HH:mm:ss" ) : ''
						);
					}
				},
				{
					title: "关联单号",
					align: "center",
					key: "associatedNumber",
					width: 230
				},
				{
					title: "关联中心仓",
					align: "center",
					key: "associatedRepositoryId",
					width: 150,
					render: ( h, params ) => {
						let idName = "";
						if (
							params.row.associatedRepositoryId &&
							params.row.associatedRepositoryName
						) {
							idName = `${ params.row.associatedRepositoryId }_${
								params.row.associatedRepositoryName
								}`;
						} else {
							idName = "";
						}
						return h( "div", {}, idName );
					}
				},
				{
					title: "关联房间",
					align: "center",
					key: "associatedRoomId",
					width: 150,
					render: ( h, params ) => {
						let idRoom = "";
						if ( params.row.associatedRoomId && params.row.associatedRoomName ) {
							idRoom = `${ params.row.associatedRoomId }_${
								params.row.associatedRoomName
								}`;
						} else {
							idRoom = "";
						}
						return h( "div", {}, idRoom );
					}
				},
				{
					title: "更新状态",
					align: "center",
					key: "updateStatus",
					width: 100
				}
			]
		};
	},
	mounted() {
		this.queryAccountList();
		this.$Notice.config( {
			top: 200
		} )
	},
	methods: {
		async queryAccountList() {
			this.queryParams.beginDate = this.dateTime[0]
				? Moment( this.dateTime[0] ).format( "YYYY-MM-DD HH:mm:ss" )
				: "";
			this.queryParams.endDate = this.dateTime[1]
				? Moment( this.dateTime[1] ).format( "YYYY-MM-DD 23:59:59" )
				: "";
			this.queryParams.goodsCatalog = this.goodsdetailsParams.goodsCatalog == 0 ? '' : this.goodsdetailsParams.goodsCatalog;
			this.queryParams.entryExitType = this.goodsdetailsParams.entryExitType == 0 ? '' : this.goodsdetailsParams.entryExitType;
			this.queryParams.updateType = this.goodsdetailsParams.updateType == 0 ? '' : this.goodsdetailsParams.updateType;
			this.queryParams.updateStatus = this.goodsdetailsParams.updateStatus == 0 ? '' : this.goodsdetailsParams.updateStatus;
			this.queryParams.cleanerId = this.goodsdetailsParams.cleanerId;
			// 加载loading
			this.materialLoading = true;
			let resp = ( await API.omsAPI[this.env].cleaner.MmStewardGoodsInventoryParticular( this.queryParams, this.token ) )
				.data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取列表失败",
					desc: resp.msg
				} );
				return;
			}
			this.accountList = resp.list || [];
			this.listTotal = resp.totalCount;
			this.materialLoading = false;
		},
		//查询
		queryAccountKeywords() {
			this.queryParams = Object.assign( {}, this.goodsdetailsParams );
			this.queryAccountList();
		},
		// 分页
		changePage( page ) {
			this.queryParams.page = page;
			this.queryAccountList();
		},
		changePageSize( pageSize ) {
			this.queryParams.page = 1;
			this.queryParams.pageSize = pageSize;
			this.queryAccountList();
		},
		//表格
		exportTable() {
			if ( !Utils.hasPermission( 'excel_MmMonthlyStewardGoodsInventory' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
			if ( this.accountList.length === 0 ) {
				this.$Notice.error( {
					title: "没数据可导"
				} );
				return;
			}
			let params = {
				associatedNumber: this.queryParams.associatedNumber,
				associatedRepositoryName: this.queryParams.associatedRepositoryName,
				associatedRoomName: this.queryParams.associatedRoomName,
				entryExitType: this.queryParams.entryExitType,
				goodsCatalog: this.queryParams.goodsCatalog,
				goodsName: this.queryParams.goodsName,
				cleanerId: this.queryParams.cleanerId,
				associatedCityName: this.queryParams.associatedCityName,
				updateStatus: this.queryParams.updateStatus,
				page: 1,
				pageSize: 999999,
				updateType: this.queryParams.updateType,
				beginDate: this.queryParams.beginDate
					? Moment( this.queryParams.beginDate ).format( "YYYY-MM-DD HH:mm:ss" )
					: "",
				endDate: this.queryParams.endDate
					? Moment( this.queryParams.endDate ).format( "YYYY-MM-DD HH:mm:ss" )
					: ""
			};
			const initParam = params => {
				let paramStr = "";
				Object.keys( params ).forEach( item => {
					if ( params[item] !== "" ) {
						paramStr += item + "=" + params[item] + "&";
					}
				} );
				return paramStr.substring( 0, paramStr.lastIndexOf( "&" ) );
			};
			let paramStr = initParam( params );
			let url = `${
				Config[this.env].analysisUrl
				}excel/MmStewardGoodsInventoryParticular?${ paramStr }`;
			// window.open(url, "_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )

		},
		preventSubmit() {
			return false;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/pages/cleaner/materialUpdateDetails-list.vue